import React from 'react';
import { Skeleton } from 'antd';

export const ScreenSkeleton: React.FC = () => (
  <div style={{ padding: '16px' }}>
    <Skeleton active paragraph={{ rows: 4 }} />
    <Skeleton active paragraph={{ rows: 3 }} style={{ marginTop: 16 }} />
    <Skeleton active paragraph={{ rows: 2 }} style={{ marginTop: 16 }} />
  </div>
);
